import { addToDbgQueue, getQueueStatus } from './dbGalleryRequests'
import { sleep } from '../shared/utils'



class DBGPhotoManager {
 


  async addToQueue(queueItems, userToken){
    return await addToDbgQueue(queueItems, userToken)
  }

  async pollForQueueUpdatesUntilEmpty(userToken, progress, endCallback){
    let status = await getQueueStatus(userToken)
    console.log('init getting status of DBG queue', userToken, status)
    if(this.polling){
      console.log('already polling DBGqueue...')
      return false
    }
    this.polling = true
    while(status.isRunning){
      await sleep(5000)
      status = await getQueueStatus(userToken)
      console.log('got status of DBG queue', status)
      progress(status)
    }
    this.polling = false
    console.log('after while', status)
    endCallback()
    return status
  }
 

}

export {DBGPhotoManager}
